// Tipos de documento de identidad - Colombia
export const TIPOS_IDENTIFICACIONES = [
  { value: "CC", text: "Cédula de Ciudadanía" },
  { value: "CE", text: "Cédula de Extranjería" },
  { value: "PA", text: "Pasaporte" },
  { value: "NIT", text: "NIT" },
  { value: "OT", text: "Otro" },
];

// Tipo de póliza (Colombia)
export const TIPOS_PLAN_GENERAL = [
  { value: "V", text: "Vida Grupo" },
  { value: "D", text: "Vida Grupo Deudores" },
  { value: "A", text: "Accidentes Personales" },
];

// Procedimiento (Colombia)
export const TIPOS_PROCEDIMIENTO = [
  { value: "INCLUSION", text: "Inclusión" },
  { value: "AUMENTO", text: "Aumento valor asegurado" },
  { value: "ACTUALIZACION", text: "Actualización de datos" },
];

// Parentesco para beneficiarios
export const TIPOS_BENEFICIARIOS = [
  { value: "CY", text: "Cónyuge" },
  { value: "HJ", text: "Hijo(a)" },
  { value: "HN", text: "Hermano(a)" },
  { value: "MD", text: "Madre" },
  { value: "PD", text: "Padre" },
  { value: "OT", text: "Otro" },
];

export const TIPOS_SEXO = [
  { value: "M", text: "Masculino" },
  { value: "F", text: "Femenino" },
];

export const TIPOS_SINO = [
  { value: "S", text: "Sí" },
  { value: "N", text: "No" },
];
